module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAAAXNSR0IArs4c6QAAAMxJREFUSEvdlTESAUEQRd+vsoFEKhcJHcEZJAKuoVxB4DgS7qKQKCegiqAVtbs1u+wGs70Bk/f7PX9+94gWj1pk86dwM0uARNI1xr5KW8ysB2yBvaS5GzwF74A+MJZ0coF7gV/NFGzxBBfg3uAcHoCHwBQ4xngc1Bwk3d+2mNkSWDUEhuULSesM3gU2wAiYOHR+lvTIH9TMMoFBk/iF7ZfT4irwMaGeN/g6/l4Cdbsls+giaRaTpNp9nm7FjqSbOzwGWJmWprBy/e9+c097d00Y/+Ux1QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/trans_back_icon.png
// module id = GinT
// module chunks = 1